import { render, staticRenderFns } from "./adm_definir_anoSemestre.vue?vue&type=template&id=73f350e5&scoped=true&"
import script from "./adm_definir_anoSemestre.vue?vue&type=script&lang=js&"
export * from "./adm_definir_anoSemestre.vue?vue&type=script&lang=js&"
import style0 from "./adm_definir_anoSemestre.vue?vue&type=style&index=0&id=73f350e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f350e5",
  null
  
)

export default component.exports